import { Text, View } from '@react-pdf/renderer'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFRow from '@/components/ReportPDF/PDFRow'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const Header = ({ title }) => (
  <PDFCell flex={2} style={{ padding: 0, alignItems: 'stretch' }}>
    <PDFCell
      style={{
        backgroundColor: `#4c82bf`,
        border: 'none',
      }}
    >
      <Text style={{ color: 'white' }}>{title}</Text>
    </PDFCell>
    <PDFRow style={{ margin: -0.5 }}>
      <PDFCell flex={1} style={{ backgroundColor: '#d7e0ed' }}>
        <Text>人數</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#d7e0ed' }}>
        <Text>比率</Text>
      </PDFCell>
    </PDFRow>
  </PDFCell>
)

const Chapter4Page = ({ reportData, setPage }) => {
  const { phishCampaignReport } = reportData || {}

  const {
    userCount,
    fileCount,
    linkCount,
    openCount,
    textCount,
    openPercent,
    linkPercent,
    filePercent,
    textPercent,
  } = phishCampaignReport || {}

  const formatPercent = value => {
    if (value != null) {
      return Number(value).toFixed(2) // 強制保留兩位小數
    }
    return '0.00' // 無效值回傳 '0.00'
  }

  const formattedReport = {
    userCount,
    openCount,
    openPercent: formatPercent(openPercent),
    linkCount,
    linkPercent: formatPercent(linkPercent),
    fileCount,
    filePercent: formatPercent(filePercent),
    textCount,
    textPercent: formatPercent(textPercent),
  }

  return (
    <PDFPage title="第四章 測試分析報告" reportData={reportData}>
      <View
        style={{
          width: '100%',
          height: 5, // 設置分隔線的高度
          backgroundColor: 'black', // 設置顏色為黑色
        }}
      >
        <PDFDivider style={{ width: '100%' }} />
      </View>
      <Text
        style={{
          marginTop: 20,
        }}
        render={({ pageNumber }) => {
          setPage({ chap4: pageNumber })
        }}
      />

      <PDFTitle hideDivider>4.1 受測者總結果統計</PDFTitle>
      <Text
        render={({ pageNumber }) => {
          setPage({ chap4_1: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}依照測試結果分析，列出整體結果統計圖表，依據
          <Text style={{ fontWeight: 'bold', fontSize: 20 }}>各類型範本郵件</Text>
          檢測結果，蒐集所有檢測數據所統計出的整體人數結果統計圖表。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}依照
          <Text style={{ fontWeight: 'bold', fontSize: 20 }}>受測人數</Text>
          統計之
          <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
          之人數統計報表：
        </PDFParagraph>

        <View style={{ display: 'flex', flexDirection: 'row' }}>
          <View style={{ flex: 1 }} />
          <Text>單位：人</Text>
        </View>

        <PDFRow style={{ fontWeight: 'bold' }} width={1075} marginLeft={-85}>
          <PDFCell
            flex={1}
            style={{
              backgroundColor: `#4c82bf`,
            }}
          >
            <Text style={{ color: 'white' }}>受測人數</Text>
          </PDFCell>
          <Header title={'瀏覽信件'} />

          <Header title={'點閱連結'} />

          <Header title={'開啟附件'} />

          <Header title={'輸入資料'} />
        </PDFRow>

        <PDFRow width={1075} marginLeft={-85}>
          <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
            <Text>{formattedReport.userCount || 0}</Text>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{formattedReport.openCount || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{formattedReport.openPercent || 0}%</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{formattedReport.linkCount || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{formattedReport.linkPercent || 0}%</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{formattedReport.fileCount || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{formattedReport.filePercent || 0}%</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{formattedReport.textCount || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{formattedReport.textPercent || 0}%</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>
        </PDFRow>
      </View>
    </PDFPage>
  )
}

export default Chapter4Page
